export const init = () => {
    const observer = new MutationObserver(() => {
        const buttons = document.querySelectorAll('.js-password-button');
        const inputs = document.querySelectorAll('.js-password');
        buttons.forEach((curr, i) => {
            curr.addEventListener('click', () => {
                inputs.forEach((item, j) => {
                    if (i === j) {
                        if (item.type === "password") {
                            try {
                                item.type = "text"; 
                                curr.classList.add('active');
                            }
                            catch (e) {
                                console.log('Exception thrown: ' + e);
                            }
                        } 
                        else {
                            try {
                                item.type = "password";
                                curr.classList.remove('active');
                            }
                            catch (e) {
                                console.log('Exception thrown: ' + e);
                            }
                        }
                    }
                })
            });
        });
    })
    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: false
    })
};